import React, { useEffect, useState } from "react"

const STORAGE_KEY = "PrivatePolicy"
const SUPPORT_EMAIL = "hotro@onlive.vn"
const HOTLINE = "1900 866 666 (nhánh 2)"

const DEFAULT_CHECKS = {
  improve: false,
  marketing: false,
  research: false,
  commercial: false
}

const ChinhSachBaoMat = ({ isShow = false, onSectionChange }) => {
  const getInitialChecks = () => {
    try {
      if (typeof window !== "undefined") {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (raw) return { ...DEFAULT_CHECKS, ...JSON.parse(raw) }
      }
    } catch (e) {
      console.error("Failed to read from localStorage:", e)
    }
    return { ...DEFAULT_CHECKS }
  }

  const [checks, setChecks] = useState(getInitialChecks)

  useEffect(() => {
    // persist changes and notify parent
    try {
      if (typeof window !== "undefined") localStorage.setItem(STORAGE_KEY, JSON.stringify(checks))
    } catch (e) {
      console.error("Failed to save to localStorage:", e)
    }
    onSectionChange?.(checks)
  }, [checks, onSectionChange])

  const handleChange = (key, value) => {
    setChecks((prev) => ({ ...prev, [key]: value }))
  }

  const checkboxes = [
    {
      key: "improve",
      label: "Tôi đồng ý để ON Live TV xử lý thông tin cá nhân của tôi nhằm nâng cao chất lượng sản phẩm, dịch vụ."
    },
    {
      key: "marketing",
      label:
        "Tôi đồng ý để ON Live TV xử lý thông tin cá nhân của tôi cho mục đích tiếp thị, quảng cáo, giới thiệu các sản phẩm, hàng hoá, dịch vụ và hoạt động có tính chất thương mại phù hợp."
    },
    {
      key: "research",
      label:
        "Tôi đồng ý để ON Live TV xử lý thông tin cá nhân của tôi cho mục đích nghiên cứu thị trường, khảo sát thăm dò ý kiến khách hàng và môi giới."
    },
    {
      key: "commercial",
      label: "Tôi đồng ý để ON Live TV xử lý thông tin cá nhân của tôi nhằm giới thiệu và xúc tiến thương mại."
    }
  ]
  return (
    <>
      <p>
        <strong>CHÍNH SÁCH BẢO MẬT</strong>
      </p>

      <p>
        <strong>
          <em>(Áp dụng từ ngày 21/8/2025)</em>
        </strong>
      </p>

      <p>
        Dịch vụ ON Live TV (&quot;ON Live TV&quot;) là dịch vụ phát thanh, truyền hình - cung cấp video theo yêu cầu
        trên mạng Internet do Công ty Cổ phần Truyền hình Tương tác Việt Nam phát triển. ON Live TV cho phép người dùng
        có thể truy cập để xem các chương trình eSports, thể thao, giải trí và các nội dung video khác vào bất cứ thời
        gian nào người dùng mong muốn trên các thiết bị và/hoặc nền tảng khác nhau thông qua mạng Internet. Bằng việc sử
        dụng dịch vụ ON Live TV, Quý Khách hàng đồng ý và chấp thuận bị ràng buộc về pháp lý bởi các quyền và nghĩa vụ
        phát sinh theo quy định tại Quy chế này.
      </p>

      <p>
        <strong>1. KHAI BÁO KHI SỬ DỤNG</strong>
      </p>

      <p>
        Tất cả nội dung bạn xem được trên ON Live TV nhằm phục vụ nhu cầu thông tin của bạn và giúp bạn lựa chọn dịch
        vụ. Vì thế, bạn được sử dụng ON Live TV mà không cần cung cấp bất kỳ thông tin cá nhân nào. Tuy nhiên, trong một
        số trường hợp, khi liên quan đến việc đăng ký dịch vụ, chúng tôi có thể yêu cầu bạn cung cấp thông tin cá nhân.
      </p>

      <p>
        <strong>2. THÔNG TIN CÁ NHÂN DO BẠN CUNG CẤP</strong>
      </p>

      <p>
        Khi bạn cung cấp các thông tin cần thiết, chúng tôi sẽ sử dụng chúng để đáp ứng yêu cầu của bạn, hoặc chúng tôi
        có thể liên lạc với bạn qua thư từ, email, tin nhắn hay điện thoại; hoặc tuân theo quy định của pháp luật hiện
        hành, sử dụng các phương tiện trên để giới thiệu đến bạn những sản phẩm, dịch vụ hay chương trình khuyến mãi mới
        từ ON Live TV. Khi cung cấp thông tin cho chúng tôi qua ON Live TV này, bạn hiểu rõ và chấp thuận việc thu thập,
        sử dụng và tiết lộ những thông tin cá nhân nêu trên cho một số mục đích được quy định trong trang này. Bạn hoàn
        toàn đồng ý và chấp thuận rằng những thông tin cá nhân bạn cung cấp khi sử dụng ON Live TV có thể được bảo lưu
        tại trụ sở hay của ON Live TV, có thể được lưu trữ tại một số máy chủ hiện có hay chưa biết trước cho mục đích
        vận hành và phát triển ON Live TV cũng như các dịch vụ của ON Live TV. Chúng tôi sẽ không cung cấp thông tin của
        bạn cho một bên thứ ba mà không được sự cho phép của bạn, trừ trường hợp bị pháp luật hiện hành bắt buộc hoặc
        trường hợp cần thiết để xử lý các vấn đề liên quan đến pháp luật. ON Live TV cam kết bảo vệ sự riêng tư của bạn,
        không mua bán thông tin cá nhân của bạn cho các công ty khác vì các mục đích khuyến mãi.
      </p>

      <p>
        <strong>ON Live TV sẽ thu thập những thông tin gì và sử dụng chúng như nào?</strong>
      </p>

      <p>
        Theo quy định của pháp luật Việt Nam và nhằm tối ưu hóa dịch vụ được cung cấp cho bạn, ON Live TV sẽ thu thập và
        lưu trữ các thông tin sau đây:
      </p>

      <div className="overflow-x-auto">
        <table className="w-full text-sm leading-relaxed border-collapse">
          <thead>
            <tr className="text-left">
              <th className="pb-2 pr-4 font-semibold">Thông tin cá nhân</th>
              <th className="pb-2 font-semibold">Sử dụng</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-t border-[#2A2A2A]">
              <td className="py-3 pr-4 align-top">Tên đăng nhập</td>
              <td className="py-3">
                Chúng tôi sử dụng thông tin này để tạo tài khoản cho ON Live TV theo yêu cầu của bạn.
              </td>
            </tr>
            <tr className="border-t border-[#2A2A2A]">
              <td className="py-3 pr-4 align-top">
                Thông tin kết nối xã hội
                <br />
                Facebook: Tên, ID Facebook, ảnh hồ sơ
                <br />
                Google: Biệt hiệu, ảnh hồ sơ
              </td>
              <td className="py-3">
                Chúng tôi sử dụng thông tin này để tạo tài khoản cho ON Live TV theo yêu cầu của bạn; chia sẻ ảnh trong
                ứng dụng trên Facebook theo yêu cầu của bạn.
              </td>
            </tr>
            <tr className="border-t border-[#2A2A2A]">
              <td className="py-3 pr-4 align-top">Open ID đã tạo</td>
              <td className="py-3">
                Chúng tôi tạo dữ liệu này và sử dụng dữ liệu này để lưu trữ dữ liệu của bạn (lịch sử xem và tiến trình)
                cùng với hồ sơ của bạn.
              </td>
            </tr>
            <tr className="border-t border-[#2A2A2A]">
              <td className="py-3 pr-4 align-top">Địa chỉ IP</td>
              <td className="py-3">
                Chúng tôi sử dụng thông tin này để cải thiện các dịch vụ của mình, bao gồm cả chức năng của ON Live TV.
              </td>
            </tr>
            <tr className="border-t border-[#2A2A2A]">
              <td className="py-3 pr-4 align-top">ID thiết bị, thông tin thiết bị</td>
              <td className="py-3">
                Chúng tôi sử dụng thông tin này để cải thiện các dịch vụ của mình, cho các mục đích bảo mật và xác minh,
                xác định và giải quyết các lỗi và đánh giá chức năng để tối ưu hóa; và để chống lại việc người dùng đăng
                ký nhiều tài khoản.
              </td>
            </tr>
            <tr className="border-t border-[#2A2A2A]">
              <td className="py-3 pr-4 align-top">Thông tin liên quan đến bảo mật</td>
              <td className="py-3">
                Chúng tôi sử dụng thông tin này cho mục đích bảo mật và xác minh; xác định và giải quyết các lỗi và đánh
                giá chức năng để tối ưu hóa hành động; giải quyết lỗi ứng dụng và tối ưu hóa khả năng tương thích của
                thiết bị với ứng dụng.
              </td>
            </tr>
            <tr className="border-t border-[#2A2A2A]">
              <td className="py-3 pr-4 align-top">Thông tin khảo sát và nội dung của các câu trả lời khảo sát</td>
              <td className="py-3">Chúng tôi sử dụng thông tin này để cải thiện dịch vụ của mình.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        ON Live TV sẽ lưu trữ các Thông tin cá nhân do bạn cung cấp trên các hệ thống nội bộ của chúng tôi trong suốt
        quá trình sử dụng dịch vụ và trong vòng 02 (hai) năm kể từ khi bạn chấm dứt sử dụng dịch vụ.
      </p>

      <p>
        ON Live TV có quyền sử dụng các thông tin nêu trên để gửi đến bạn các tin nhắn, thư điện tử (email), gọi điện
        thoại và/hoặc liên hệ với bạn theo bất kỳ cách thức nào mà ON Live TV lựa chọn sử dụng nhằm:
      </p>

      <p>
        - Hỗ trợ, cung ứng các dịch vụ tốt nhất cho bạn
        <br />- Gửi đến bạn các thông tin, nội dung nhằm mục đích quảng cáo dịch vụ của ON Live TV
        <br />- Phân tích, đo lường hiệu quả các dịch vụ mà bạn sử dụng
        <br />- Liên hệ trực tiếp với bạn để nhằm mục đích chăm sóc khách hàng, xác thực thông tin và các mục đích khác.
      </p>

      <p>
        ON Live TV sẽ cung cấp, chia sẻ các thông tin cá nhân, dữ liệu và/hoặc các thông tin khác của bạn mà ON Live TV
        lưu trữ trong các trường hợp sau đây:
      </p>

      <p>
        - Được sự đồng ý của bạn.
        <br />- Theo yêu cầu của Tòa án và/hoặc Cơ quan Nhà nước có thẩm quyền.
      </p>

      <p>
        ON Live TV sẽ thực hiện các biện pháp kỹ thuật cần thiết để bảo mật thông tin của bạn, bao gồm không giới hạn ở
        việc (I) mã hóa thông tin theo tiêu chuẩn phù hợp, (II) thiết lập các hệ thống tường lửa để ngăn chặn việc xâm
        nhập trái phép, (III) sử dụng dịch vụ máy chủ, chỗ đặt máy chủ tại các đơn vị, doanh nghiệp có tiêu chuẩn bảo
        mật cao.
      </p>

      <p>
        <strong>3. GHI NHẬN THÔNG TIN TRÌNH DUYỆT</strong>
      </p>

      <p>
        Đôi khi, thông tin có thể được đưa vào máy tính của bạn để giúp chúng tôi nâng cấp ON Live TV hay cải thiện chất
        lượng dịch vụ cho bạn. Những thông tin này thường được biết đến dưới dạng các &quot;cookies&quot; mà nhiều ON
        Live TV hiện cũng đang sử dụng. &quot;Cookies&quot; là những mẩu thông tin lưu trữ trong đĩa cứng hay trình
        duyệt trên máy tính của bạn, không phải trên ON Live TV. Chúng cho phép thu thập một số thông tin về máy tính
        của bạn như địa chỉ IP, hệ điều hành, chế độ trình duyệt và địa chỉ của các ON Live TV liên quan. Nếu bạn không
        muốn nhận các cookies này, hoặc muốn được thông báo khi các cookies này được đặt vào, bạn có thể cài đặt chế độ
        trình duyệt của bạn thực hiện điều này nếu trình duyệt của bạn hỗ trợ. Vui lòng lưu ý, nếu bạn tắt chế độ nhận
        cookies, bạn sẽ không thể truy cập hay sử dụng một số tiện ích trên ON Live TV mà không được xác định trước.
        Chúng tôi không cố ý hạn chế việc sử dụng của bạn trong tình huống này, đây chỉ là giới hạn trong việc lập trình
        và xây dựng ON Live TV.
      </p>

      <p>
        <strong>4. AN TOÀN THÔNG TIN</strong>
      </p>

      <p>
        Khi lập trình ON Live TV, chúng tôi có thể đặt những luật định hợp lý mang tính thương mại để ngăn chặn hành vi
        truy cập bất hợp pháp và việc sử dụng không thích đáng các thông tin cá nhân của bạn đã gửi cho ON Live TV thông
        qua việc sử dụng ON Live TV này. Vì luôn có những rủi ro liên quan đến vấn đề cung cấp dữ liệu cá nhân, cho dù
        là cung cấp trực tiếp, qua điện thoại hay qua mạng internet, hay qua các phương tiện kỹ thuật khác; và không có
        hệ thống kỹ thuật nào an toàn tuyệt đối hay chống được tất cả các &quot;hacker&quot; và &quot;tamper&quot;
        (người xâm nhập trái phép để lục lọi thông tin), ON Live TV luôn nỗ lực tiến hành những biện pháp đề phòng thích
        hợp đối với từng đặc tính của thông tin để ngăn chặn và giảm thiểu tối đa các rủi ro có thể khi bạn sử dụng ON
        Live TV này.
      </p>

      <p>
        <strong>5. GIỚI HẠN THIẾT BỊ TƯƠNG THÍCH</strong>
      </p>

      <p>
        Hiệu năng của ứng dụng ON Live TV phụ thuộc vào mẫu điện thoại, máy tính bảng, thiết bị thông minh Android mà
        bạn sử dụng, bên cạnh đó là hệ điều hành, phiên bản hệ điều hành, ngôn ngữ, nhà mạng của bạn. Để tìm hiểu hệ
        điều hành được ứng dụng ON Live TV hỗ trợ vui lòng xem dưới đây:
      </p>

      <p>
        iOS (Apple Smartphone): iOS 12.0 hoặc mới hơn.
        <br />
        Android (Android Smartphone/Tablet): Android 7 hoặc mới hơn.
        <br />
        iPadOS (Apple iPad): iPadOS 10.0 hoặc mới hơn.
        <br />
        Trình duyệt web: Chrome, Edge, Firefox.
      </p>

      <p>
        ON Live TV không giải quyết các khiếu nại liên quan đến hiệu năng hoặc nội dung cung cấp của ứng dụng trên các
        thiết bị đã rooted, jailbreak, hack.
      </p>

      <p>
        <strong>6. THÔNG TIN QUA EMAIL</strong>
      </p>

      <p>
        Khi bạn đăng ký dịch vụ, địa chỉ email của bạn cung cấp sẽ dùng làm công cụ trao đổi thông tin với bạn. Trước
        hết bạn hãy chắc rằng bạn cung cấp địa chỉ email hữu dụng đối với bạn trong suốt quá trình sử dụng dịch vụ.
        Chúng tôi có thể gửi những thông tin bí mật qua email hay tiếp nhận yêu cầu hỗ trợ của bạn. Trong trường hợp bạn
        không còn sử dụng email đã cung cấp, bạn phải báo cho chúng tôi để về việc thay đổi này. Để bảo vệ bạn, ON Live
        TV có thể tạm thời ngừng tiếp nhận yêu cầu qua email bạn đã cung cấp nếu nhận thấy có sự gian lận hoặc thông tin
        bất thường - cho đến khi chúng tôi liên hệ được với bạn để xác nhận.
      </p>

      <p>
        <strong>7. ĐIỀU CHỈNH THÔNG TIN</strong>
      </p>

      <p>
        ON Live TV sẽ chủ động hoặc theo yêu cầu của bạn bổ sung, hiệu chỉnh hay xóa các dữ liệu thông tin cá nhân không
        chính xác, không đầy đủ hoặc không cập nhật khi bạn còn liên kết với hoạt động của chúng tôi.
      </p>

      <p>
        <strong>8. LIÊN KẾT NGOÀI ON LIVE TV</strong>
      </p>

      <p>
        ON Live TV này có thể chứa các đường liên kết đến các ON Live TV khác được đặt vào nhằm mục đích giới thiệu hoặc
        bổ sung thông tin liên quan để bạn tham khảo. ON Live TV không chịu trách nhiệm về nội dung hay các hành vi của
        bất kỳ ON Live TV nào khác.
      </p>

      <p>
        <strong>9. XÓA THÔNG TIN VÀ TÀI KHOẢN TRÊN HỆ THỐNG</strong>
      </p>

      <p>9.1. Quyền xóa thông tin tài khoản:</p>

      <p>
        Bạn có thể tự xóa/yêu cầu xóa thông tin của mình đã đăng ký với ON Live TV hoặc xóa tài khoản của mình bằng cách
        các cách thức như sau
      </p>

      <p>
        - Thực hiện thao tác xóa tài khoản trên thiết bị đã đăng nhập tài khoản muốn xóa, lưu ý: khi bạn thực hiện
        &quot;Xác nhận&quot; đồng nghĩa với việc đồng ý với các điều khoản trong việc xóa tài khoản đã được nêu.
      </p>

      <p>
        - Gửi yêu cầu bằng văn bản hoặc email cho bộ phận CSKH của chúng tôi tại địa chỉ {SUPPORT_EMAIL} và trực tiếp
        qua hotline {HOTLINE}, và chúng tôi sẽ xử lý yêu cầu dựa theo các quy định Chính Sách Bảo Mật này và các nghĩa
        vụ của chúng tôi được quy định bởi pháp luật.
      </p>

      <p>9.2. Quyền yêu cầu truy cập và điều chỉnh thông tin</p>

      <p>
        9.2.1. Nếu bạn đã đăng ký một tài khoản với chúng tôi, bạn có thể truy cập và chỉnh sửa dữ liệu cá nhân của bạn
        mà chúng tôi đang lưu giữ thông qua Thiết lập tài khoản. Nếu bạn chưa đăng ký tài khoản với chúng tôi, cá nhân
        bạn có thể yêu cầu truy cập và chỉnh sửa dữ liệu cá nhân của bạn mà chúng tôi đang lưu giữ hoặc kiểm soát bằng
        cách gửi yêu cầu bằng văn bản cho chúng tôi. Chúng tôi sẽ cần đầy đủ thông tin từ bạn để xác định danh tính của
        bạn cũng như bản chất yêu cầu của bạn để xử lý cho bạn. Do đó, vui lòng gửi yêu cầu bằng văn bản của bạn cho
        chúng tôi thông qua email {SUPPORT_EMAIL}.
      </p>

      <p>
        9.2.2. Chúng tôi bảo lưu quyền từ chối sửa dữ liệu cá nhân của bạn theo các quy định của pháp luật về bảo vệ bí
        mật thông tin cá nhân, trường hợp các điều luật đó yêu cầu và/hoặc cho phép một tổ chức từ chối sửa dữ liệu cá
        nhân trong các trường hợp như thế.
      </p>

      {isShow && (
        <>
          <p>
            Tôi, với tư cách là Bên cung cấp thông tin của người tiêu dùng, tùy chọn đồng ý cho phép ON Live TV thu thập
            và xử lý các thông tin do tôi cung cấp, cũng như các thông tin khác được xác định là thông tin cá nhân theo
            quy định tại Chính sách bảo mật này và theo quy định của pháp luật hiện hành nhằm mục đích:
          </p>
          {checkboxes.map(({ key, label }) => (
            <div key={key} className="mt-4">
              <label className="flex cursor-pointer items-start gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={!!checks[key]}
                  onChange={(e) => handleChange(key, e.target.checked)}
                  className="mt-1 h-4 w-4 shrink-0 accent-primary"
                />
                <span>{label}</span>
              </label>
            </div>
          ))}
        </>
      )}
    </>
  )
}

export default ChinhSachBaoMat
